import Image from 'next/image'
import QRCode from 'qrcode'
import { ComponentProps, FC, useEffect, useState } from 'react'

import { useAppQR } from '@/api/models/common/hooks/useAppQR'
import { AppLoader } from '@/components/shared/loader'
import { AppModal } from '@/components/shared/modal'
import {
  QrStoreType,
  StoreName
} from '@/components/widgets/sidebar/ui/Sidebar.types'

type Props = Omit<
  ComponentProps<typeof AppModal> & {
    store: QrStoreType
  },
  'title'
>

const AppQrModal: FC<Props> = ({ store, ...props }) => {
  const { data: appQR } = useAppQR()

  const apiAppQRSrc = appQR?.[store]

  const [qrCode, setQrCode] = useState('')

  useEffect(() => {
    if (apiAppQRSrc) {
      QRCode.toDataURL(apiAppQRSrc, (_, url) => {
        setQrCode(url)
      })
    }
  }, [apiAppQRSrc])

  return (
    <AppModal
      className="max-w-[498px]"
      title={<>Скачайте мобильное приложение Sminex в {StoreName[store]}</>}
      {...props}
    >
      <div className="flex justify-center">
        <div className="flex h-[260px] w-[260px] items-center justify-center overflow-hidden rounded-12 bg-white p-4">
          {qrCode ? (
            <Image
              src={qrCode}
              alt={StoreName[store]}
              width={260}
              height={260}
            />
          ) : (
            <AppLoader />
          )}
        </div>
      </div>
    </AppModal>
  )
}

export { AppQrModal }
